(function() {
  'use strict';
  
  angular
    .module('app.shell')
    .directive('marsUnreadBadge', marsUnreadBadge);
      
  marsUnreadBadge.$inject = ['$log'];
    
  function marsUnreadBadge($log) {
    $log = $log.getInstance('marsUnreadBadge');
    
    var directive = {
      restrict: 'E',
      scope: {
        unread: '='
      },
      templateUrl: 'app/shell/unread-badge.directive.html',
      replace: true
    }
    return directive;
  }
  
})();